import type { GetTriageSettingsPageDataResponse } from '@provision/entity-types';

// Mirrors `@provision/entity-types` `TriageActionVisibility` (same string values).
// Declared locally because the portal consumes entity-types as types only — its
// CommonJS barrel does not expose runtime enum values to Vite.
export enum TriageActionVisibility {
  AutoApply = 'auto_apply',
  Show = 'show',
  Hide = 'hide',
}

export interface GetTriageSettingsPageDataQuery {
  getTriageSettingsPageData: GetTriageSettingsPageDataResponse;
}

export type TriageActionConfigSnapshot = Record<string, { visibility: string }>;

export interface SoftDeleteConversationTriageMutation {
  softDeleteConversationTriage: boolean;
}

export interface SetDefaultConversationTriageMutation {
  setDefaultConversationTriage: boolean;
}
